const QUERIES = {
  USERS_LIST: 'users-list',
  USER_LIST: 'user-list',
  ORDER_LIST:'order_list',
  ATTENDANCE_LIST:'attendance_list',
  WAREHOUSE_LIST: 'warehouse-list',
  DEALER_LIST: 'dealer-list',
  BEAT_LIST:'beat_list',
  OUTLET_LIST:'outlet_list',
  ZONE_LIST:'zone_list',
  STATE_LIST:'state_list',
  CITY_LIST:'city_list',
  DISTRICT_LIST:'district_list',
  AREA_LIST:'area_list',
  ITEM_LIST:'item_list',
  MTP_LIST:'mtp_list',
  ORDERS_LIST:'orders',
  RETURN_ORDER_LIST:'return_order_list',
  LEAVE_LIST:'leave_list',
  ROLE_LIST:'role_list',
  DESIGNATION_LIST:'designation_list',
  DIVISION_LIST:'division_list',
  SCHEME_LIST:'scheme_list',
  EXPENSE_LIST:'expense_list',
  OUTLET_CATEGORY_LIST:'outlet_category_list',
  OUTLET_CUSTOMER_LIST:'outlet_customer_list',
  DEPARTMENT_LIST:'department_list',
  PERFORMANCE_REPORT_LIST:'performance_report_list',
  REPORT_ATTENDANCE_LIST:'report_attendance_list',
  EXPENSE_ENTRY_LIST:'expense_entry_list',
  SKU_ORDER_DETAILS_REPORT:'sku_order_details_repoert',
  EXPENSE_REPORT_LIST:'expense_report_list'
}

export {QUERIES}
